export const automaticEditActivityID = (state) =>
  state.automaticEdit.automaticEditActivityID[0];

export const getLocationUpdated = (state) =>
  state.automaticEdit.automaticEditInitialized;
